

const IndexActivitiesItemSchema = {
  createdAt: { format: 'date-time' },
  updatedAt: { format: 'date-time' }
}

export default IndexActivitiesItemSchema
